import { Component, Input } from '@angular/core';
import { NavController } from "ionic-angular";
import { SpecialsdashboardPage } from "../../pages/specialsdashboard/specialsdashboard";


@Component({
  selector: 'list-view',
  templateUrl: 'list-view.html'
})
export class ListViewComponent {

  @Input()
  items = [];
  @Input()
  container: string;
  @Input()
  defaultImage: string;
  @Input()
  listTitle?: string;
  loading?: boolean;
  constructor(public navCtrl: NavController) {
    console.log('Hello ListViewComponent Component');

  }
  goToEditSpecial(special: any) {
    this.navCtrl.push(SpecialsdashboardPage, { specialItem: special })
  }
}



// WEBPACK FOOTER //
// ./src/components/list-view/list-view.ts